import { render } from "./PostCommunity.view.vue?vue&type=template&id=65eb8e46"
import script from "./PostCommunity.view.vue?vue&type=script&lang=js"
export * from "./PostCommunity.view.vue?vue&type=script&lang=js"

import "./PostCommunity.view.vue?vue&type=style&index=0&id=65eb8e46&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__